import React, { FC } from 'react';
import { Flex, SxProp } from 'theme-ui';
import { useOptionValue } from '~/hooks/components/use-option-value';
import { TransformedProduct } from '~/types/filter';

type Props = {
  product: TransformedProduct | Queries.ProductCardFragmentFragment;
  handleColorSwatchClick: ((optionValue: Queries.OptionValuesFragmentFragment) => void) | undefined;
  selectedColor: Queries.OptionValuesFragmentFragment | null | undefined;
  forwardSx?: SxProp['sx'];
};

const QuickshopColorSwatch: FC<Props> = ({ product, forwardSx, handleColorSwatchClick, selectedColor }) => {
  const [allColors] = useOptionValue(product, 'color');

  return (
    <Flex sx={{ ...forwardSx }}>
      {allColors.map((ov) => {
        return (
          <button
            key={ov.id}
            onClick={handleColorSwatchClick ? () => handleColorSwatchClick(ov) : () => {}}
            sx={{
              cursor: 'pointer',
              aspectRatio: '1',
              minHeight: 'var(--dots)',
              minWidth: 'var(--dots)',
              backgroundColor: ov.alternateRendering || 'black',
              border: '1px solid transparent',
              borderColor: ov.alternateRendering === '#E1E1E1' && 'darkCloud',
              borderRadius: '50%',
              transition: 'all 0.2s ease-in-out',
              outline: selectedColor?.slug === ov.slug ? '1px solid black' : null,
              outlineOffset: '2px',
              position: 'relative',
              overflow: 'hidden',
              '::before': {
                content: '""',
                position: 'absolute',
                inset: 0,
                backgroundColor: ov.alternateRendering2,
                clipPath: 'polygon(100% 0, 0% 100%, 100% 100%)',
              },
            }}
          >
            <div />
          </button>
        );
      })}
    </Flex>
  );
};

export default QuickshopColorSwatch;
